import { z } from "zod";
import { TObjectBase } from "../base";

export const TRawUserFeaturePreferences = z
  .object({
    preferences: z.record(z.string(), z.boolean()),
  })
  .extend(TObjectBase.shape);

export type IRawUserFeaturePreferences = z.infer<typeof TRawUserFeaturePreferences>;
